import React, { createContext, useEffect, useMemo, useState } from "react";
import { axiosInstance } from "../../services/axiosInstance";

export const TokenContext = createContext({});

export const TokenProvider = ({ children }) => {
  const [keyCloak, setKeyCloak] = useState(null);

  const contextValue = useMemo(
    () => ({
      keyCloak,
      setKeyCloak,
    }),
    [keyCloak]
  );

  useEffect(() => {
    if (!keyCloak || !keyCloak.token) return;

    const token = keyCloak.token;

    axiosInstance.interceptors.request.use(
      (config) => {
        config.headers["Authorization"] = `Bearer ${token}`;

        return config;
      },
      (error) => {
        Promise.reject(error);
      }
    );
  }, [keyCloak]);

  return (
    <TokenContext.Provider value={contextValue}>
      {children}
    </TokenContext.Provider>
  );
};
